import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IGetLecturerStatisticsByMonthData } from 'src/app/shared/models/statistics/lecturer/get-lecturer-statistics-by-month-data.model';
import { ILecturerStats } from 'src/app/shared/models/statistics/lecturer/lecturer-stats.model';
import { ILecturerProfileUpdateData } from 'src/app/shared/models/user/lecturer/lecturer-profile-update-data.model';
import { ILecturer } from 'src/app/shared/models/user/lecturer/lecturer.model';
import { CallableNames, DbService } from '../../../db.service';
import { IOrgUser } from 'src/app/shared/models/user/user.model';
import { ILocket } from 'src/app/shared/models/locket/locket.model';

export type ICallablesUsersLecturerGetResult = (ILecturer & { user: { orgUsers: IOrgUser[], lockets: ILocket[] } })[];

@Injectable({
  providedIn: 'root'
})
export class LecturersService {

  constructor(
    private dbService: DbService,
  ) { }

  public getAllLecturersInOrganization(organizationId: number): Observable<ICallablesUsersLecturerGetResult> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesUsersLecturerGet, data: { organizationId } });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getByUserId(userId: number, organizationId: number): Observable<ILecturer> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesUsersLecturerGet, data: { userId, organizationId } });
    return this.dbService.handleObs(obs, { succSilent: true }).pipe(
      map(x => {
        return x[0] ?? null;
      })
    );
  }

  public updateProfile(data: ILecturerProfileUpdateData): Observable<ILecturer> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesUsersLecturerUpdateProfile, data });
    return this.dbService.handleObs(obs);
  }

  public getStatsByMonth(data: IGetLecturerStatisticsByMonthData): Observable<ILecturerStats> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesStatisticsLecturerGetByMonth, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }
}
